import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cc4c81e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cc4c81e8&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=cc4c81e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4c81e8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonService: require('/73app-view/components/common-service.vue').default,CommonFooter: require('/73app-view/components/common-footer.vue').default})
